import React from "react"

const Loader = () => (
  <svg viewBox="25 25 50 50">
    <title>Loading indicator</title>
    <circle cx="50" cy="50" r="20" fill="none" strokeWidth="3"/>
  </svg>
)

export default Loader